// ADR-022 SYMMETRIC LIMIT — peer enforcement points:
//   - src/api/v2/buyer/_onboarding_constants.py (backend Literal SSOT)
//   - supabase/migrations/20260605120000_ftr1113_buyer_onboarding_columns.sql (DB CHECK)
// If you change one, sync the others.

export const MARKETPLACES = ['wb', 'ozon', 'ym'] as const;
export type MarketplaceCode = typeof MARKETPLACES[number];

export const CITIES = [
  'Москва',
  'СПб',
  'Екатеринбург',
  'Казань',
  'Новосибирск',
  'другой',
] as const;
